<template>
  <div>
    <div>应用拓展 - 角色扮演</div>

    <div>角色扮演ID: {{config.rpg_id}}</div>
    <div>AI角色: {{config.ai_role}}</div>
    <div>用户角色: {{config.user_role}}</div>
    <div class="pre-wrap">AI预设: {{config.ai_preset}}</div>
    <div class="pre-wrap">用户预设: {{config.user_preset}}</div>
    <div class="pre-wrap">用户任务: <br/>{{config.user_task}}</div>
    <div class="pre-wrap">进入消息: {{config.enter_msg}}</div>
    <div class="pre-wrap">需要确认: {{config.enter_ready}}</div>
    <div class="pre-wrap">第一条消息: {{config.first_msg}}</div>
    <div class="pre-wrap">下一个消息: {{config.next_msg}}</div>
    <div class="pre-wrap">完成模块消息: {{config.finish_msg || '无'}}</div>
    <SttFormat :formats="config.stt_format"/>
    <TtsFormat :formats="config.tts_format"/>

  </div>
</template>

<script>
import SttFormat from "./stt_format.vue";
import TtsFormat from "./tts_format.vue";

export default {
  name: "ai_topic",
  components: {TtsFormat,SttFormat},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
}
</script>